
export const loadAutoplayVideo = (selector) => {

	let currentWidth = [];

	const selectSrc = (video, i) => {

		const containerWidth = video.parentElement.offsetWidth;

		let videoSuffix = '';

		if (containerWidth <= 640) {
			videoSuffix = 'xs';
		} else if (containerWidth > 640 && containerWidth <= 960) {
			videoSuffix = 'sm';
		} else if (containerWidth >= 960 && containerWidth <= 1280) {
			videoSuffix = 'md';
		} else if (containerWidth >= 1280) {
			videoSuffix = 'lg';
		}

		switch (videoSuffix) {
			case 'xs':
				if (currentWidth[i] > 1) {
					return
				}
			case 'sm':
				if (currentWidth[i] > 640) {
					return
				}
			case 'md':
				if (currentWidth[i] >= 960) {
					return
				}
			case 'lg':
				if (currentWidth[i] >= 1280) {
					return
				}
		}

		currentWidth[i] = containerWidth;
		const currentTime = video.currentTime;
		video.setAttribute('src', video.getAttribute(`data-src-${videoSuffix}`));
		video.currentTime = currentTime;
	}

	(($) => {

		if (typeof selector === 'object' || typeof selector === 'undefined') {
			selector = '[data-video]';
		}

		$(selector).each(function (i, e) {
			const video = $(this).find('video').get(0);
			const repeat = $(this).data('repeat');
			const rewind = $(this).is('[data-rewind]');
			const $poster_target = $(this).prev('[data-bg-image]');
			if (!video) {
				return;
			}


			if (video) {
				if ($poster_target) {
					const poster = $poster_target.data('full-src');
					if (poster) {
						video.setAttribute('poster', poster);
					}
				}
				selectSrc(video, i);
				video.setAttribute('preload', 'preload');
				if (rewind) {
					video.currentTime = 0;
				}
				if (repeat) {
					$(video).on('ended', (e) => {
						video.currentTime = repeat;
						video.play();
					});
				}
			}
			$(window).on('resize', () => {
				selectSrc(video, i);
			})
		});

	})(jQuery);
};


